export default {
  smaller: '0.5625rem',
  small: '0.75rem',
  normal: '1rem',
  big: '1.125rem',
  bigger: '1.325rem'//'1.625rem'
}



// WEBPACK FOOTER //
// ./styles/settings/fontsizes.js